import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const Login = (data: any) =>
    POST_ENC(API_ENDPOINTS.AUTH.LOGIN, data);

export const ForgotPassword = (data: any) =>
    POST_ENC(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, data);

export const ResetPassword = (data: any) =>
    POST_ENC(API_ENDPOINTS.AUTH.RESET_PASSWORD, data);

export const SetPassword = (data: any) =>
    POST_ENC(API_ENDPOINTS.AUTH.SET_PASSWORD, data);

export const CheckIsExpireInvitation = (data: any) =>
    POST_ENC(API_ENDPOINTS.AUTH.CHECK_IS_EXPIRE_INVITATION, data);

export const RefreshToken = (data: any) =>
    POST_ENC(API_ENDPOINTS.AUTH.REFRESH_TOKEN, data);

export const Info = (params: any) =>
    GET_ENC(API_ENDPOINTS.AUTH.INFO + params, null);

